import { render } from "./SchemaRevit.vue?vue&type=template&id=82ba625a&scoped=true"
import script from "./SchemaRevit.vue?vue&type=script&lang=js"
export * from "./SchemaRevit.vue?vue&type=script&lang=js"

import "./SchemaRevit.vue?vue&type=style&index=0&id=82ba625a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ba625a"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
